import React from "react";

import WappIcono, { TIPOS } from "../../../components/wappIcono";
import { Nodo } from "../../../services/v2/wappdrive.service";

/** El tipo de archivo para su ícono y color (WappDocs, WappCell, WappDeck, WappPDF…). */
export const tipoDe = (n: Nodo): string => {
	if (n.is_folder) return "carpeta";
	if (n.editor) return n.editor;
	const m = n.mime || "";
	if (m.startsWith("image/") || ["jpg", "jpeg", "png", "gif", "webp", "heic", "svg"].includes(n.ext)) return "foto";
	if (m.startsWith("video/") || ["mp4", "mov", "avi", "mkv", "webm"].includes(n.ext)) return "video";
	if (m.startsWith("audio/") || ["mp3", "wav", "m4a", "ogg"].includes(n.ext)) return "audio";
	if (["zip", "rar", "7z"].includes(n.ext)) return "zip";
	return "otro";
};
export const Ficha: React.FC<{ n: Nodo; grande?: boolean }> = ({ n, grande }) => {
	const t = TIPOS[tipoDe(n)] || TIPOS.otro;
	return <span className={"wd-tipo" + (grande ? " grande" : "")} style={{ background: t.fondo, color: t.tinta }}><WappIcono n={t.icono} /></span>;
};

